import React, { useState } from 'react';
import { Icon } from '../../elements/icon';
import { FOCUS_AREAS } from '../../../Data/focus-areas';
import { useTranslation } from 'react-i18next';
import { findAssetByCodeOrName, normalizeAssetKey } from '../../../utils/assets';

const DEFAULT_COLLAPSED_FOCUS_AREA_COUNT = 2;

const FocusAreaAccordion = ({ focusArea, focusAreaIcons, collapsedCount = DEFAULT_COLLAPSED_FOCUS_AREA_COUNT }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const focusAreas = Array.isArray(focusArea) ? focusArea : [];
  const visibleCount = Number(collapsedCount) > 0 ? Number(collapsedCount) : DEFAULT_COLLAPSED_FOCUS_AREA_COUNT;
  const displayedItems = open ? focusAreas : focusAreas.slice(0, visibleCount);
  const hiddenCount = Math.max(focusAreas.length - visibleCount, 0);
  const hasMore = hiddenCount > 0;

  return (
    <div className="t-flex t-flex-col t-gap-2">
      <div className="t-flex t-flex-wrap t-gap-2">
        {displayedItems.map((item) => {
          const translatedIcon = findAssetByCodeOrName(focusAreaIcons?.data, item);
          const normalizedAnswer = normalizeAssetKey(item?.answer);
          const focusIcon = FOCUS_AREAS?.find(
            (focusAreaItem) =>
              focusAreaItem?.code === translatedIcon?.code ||
              focusAreaItem?.name?.some((name) => normalizeAssetKey(name) === normalizedAnswer),
          );

          return (
            <div
              key={'focus-area-' + (item?.answerCode || item?.code || item?.answer)}
              className="t-flex t-items-center t-gap-1.5 t-px-2.5 t-py-1.5 t-rounded-full t-bg-white t-border t-border-g200"
            >
              <img src={focusIcon?.img} alt="" className="t-w-4 t-h-4 t-flex-shrink-0" />
              <p className="t-m-0 t-font-sans t-text-[13px] t-font-medium t-text-navy/70">{item.answer}</p>
            </div>
          );
        })}
      </div>

      {hasMore && (
        <div className="t-flex t-gap-1 t-cursor-pointer t-w-full" onClick={() => setOpen(!open)}>
          <Icon name={open ? 'chevronUp' : 'chevronDown'} color="gray" size="16" />
          <p className="t-m-0 t-font-sans t-text-[13px] t-text-navy/50">
            {open ? t('FocusAreaHide') : t('FocusAreaShowMore', { count: hiddenCount })}
          </p>
        </div>
      )}
    </div>
  );
};

export default FocusAreaAccordion;
